
import React from "react";

import { connect } from 'react-redux';
import { getTokenForReset, resetPasswordCall } from '../actions';

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";

import {
    Container, Form,
    FormGroup, Label, Input,
    Button,
} from 'reactstrap';

import './login.css'

import NavbarRegister from "components/Navbars/NavbarRegister.js";
import { thead, tbody } from "variables/general";
import CardFooter from "reactstrap/lib/CardFooter";


import NotificationAlert from "react-notification-alert";




var ContStyle = {
    width:"50%"
  
  }
var formStyle = {
    marginTop: '60px'
}



class PasswordReset extends React.Component {
    state = {email:"",token:"",password:"",confirmPassword:"",emailPanel:true,tokenPanel:false,passwordPanel:false}

    submitLogin = () => {
        this.props.logIn(this.state)
    }
    setPassword = () => {
        this.setState({emailPanel:false,passwordPanel:true,tokenPanel:false,})
        //console.log(this.state)
    }
    setToken= () => {
        this.setState({tokenPanel:true,passwordPanel:false,emailPanel:false})
        this.props.getTokenForReset(this.state.email)
    }
    setEmail = () => {
        this.setState({tokenPanel:false,passwordPanel:false,emailPanel:true})
    }
    resetPassword = () =>{
        if (this.state.password === this.state.confirmPassword){
            this.props.resetPasswordCall(this.state)
            //console.log(this.state)
        }
        else{
            alert("Passwords Dont match")
        }
    }

    notify(place,message) {
        if (!message){
          return ""
        }
        var color = message[0];
        
        var type;
        switch (color) {
          case 'success':
            type = "success";
            break;
          case 'danger':
            type = "danger";
            break;
          case 'warning':
            type = "warning";
          default:
            break;
        }
        var options = {};
        options = {
          place: place,
          message: (
            <div>
              <div style={{height:'70px'}}>
                {message[1]}
              </div>
              
            </div>
          ),
          type: type,
          icon: "now-ui-icons ui-1_bell-53",
          autoDismiss: 10,
        };
        this.refs.notificationAlert.notificationAlert(options);
    }
    

      
    componentDidUpdate(prevProps){
        if(prevProps.message.message !== this.props.message.message && this.props.message.message){
            this.notify("br",this.props.message.message)
        }
    }
    render() {
        if (this.props.auth.token){
            localStorage.setItem("token",this.props.auth.token)
            localStorage.setItem("user",JSON.stringify(this.props.auth))
            window.location.replace("/dashboard")
        }
        return (
        <div className="image">
            <NavbarRegister {...this.props} style={{backgroundColor:'rgb(0,0,0)'}}  />
            <NotificationAlert ref="notificationAlert" />
            <Container className="App" align={'center'}>
                <Col xs={12} md={6} align={'center'}>
                    <Card style={{backgroundColor:'rgba(0,0,0,0.4)',padding:'30px',marginTop:'60px',color:'rgb(255,255,240)'}}>
                    <h2>Password Reset</h2>
                        
                    {this.state.emailPanel ? 
                        <div>
                            <Form className="form" style={formStyle}>
                            <Row>
                            <Col>
                                <FormGroup>
                                <Label style={{color:'rgb(240,240,240)'}}>Enter your Email</Label>
                                <Input
                                    style={{height:'35px'}}
                                    type="email"
                                    name="email"
                                    value = {this.state.email}
                                    onChange={e => this.setState({email:e.target.value})}
                                />
                                </FormGroup>
                            </Col>
                            </Row>
                            
                            
                            <Button onClick={this.setToken} style={{alignItem:'center',backgroundColor:'rgb(255,180,30)'}}>Next</Button>
                            </Form>
                        </div>
                    :''}
                    {this.state.tokenPanel ? 
                        <div>
                            <Form className="form" style={formStyle}>
                            <Row>
                            <Col>
                                <FormGroup>
                                <Label style={{color:'rgb(240,240,240)'}}>Copy paste the token you got on your email here</Label>
                                <Input
                                    style={{height:'35px'}}
                                    type="text"
                                    name="token"
                                    value = {this.state.token}
                                    onChange={e => this.setState({token:e.target.value})}
                                />
                                </FormGroup>
                            </Col>
                            </Row>
                            
                            
                            
                            <Button onClick={this.setPassword} style={{alignItem:'center',backgroundColor:'rgb(255,180,30)'}}>Next</Button>
                            
                            <Button onClick={this.setEmail} style={{alignItem:'center',backgroundColor:'rgb(200,50,20)'}}><i class="fas fa-arrow-left"></i></Button>
                            </Form>
                        </div>
                        :''}
                    {this.state.passwordPanel ? 
                        <div>
                            <Form className="form" style={formStyle}>
                            <Row>
                            <Col>
                                <FormGroup>
                                <Label style={{color:'rgb(240,240,240)'}}>Password</Label>
                                <Input
                                    style={{height:'35px'}}
                                    type="password"
                                    name="email"
                                    value = {this.state.password}
                                    onChange={e => this.setState({password:e.target.value})}
                                />
                                </FormGroup>
                            </Col>
                            </Row>
                            <Row>
                            <Col>
                                <FormGroup>
                                <Label style={{color:'rgb(240,240,240)'}}>Confirm Password</Label>
                                <Input
                                    style={{height:'35px'}}
                                    type="password"
                                    name="username"
                                    value = {this.state.confirmPassword}
                                    onChange={e => this.setState({confirmPassword:e.target.value})}
                                />
                                </FormGroup>
                            </Col>
                            </Row>
                            <Button onClick={this.resetPassword} style={{alignItem:'center',backgroundColor:'rgb(50,200,30)'}}>Submit</Button>
                            <Button onClick={this.setToken} style={{alignItem:'center',backgroundColor:'rgb(200,50,30)'}}><i class="fas fa-arrow-left"></i></Button>
                            </Form>
                        </div>
                    :''}
                    
                            
                    </Card>
                
                </Col>
                
                
            </Container>
          </div>
        );
      }
    }
    const mapStateToProps = (state) => {
        //console.log(state)
        return {auth:state.auth,message:state.message}
      }
    export default connect(mapStateToProps,{getTokenForReset,resetPasswordCall})(PasswordReset);
